// RatingsPage.jsx
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NoResultsSection } from "reusableComponents";
import SpaceToRateCard from "./SpaceToRateCard";
import styles from "./styles.module.scss";
import { getPlacenotes } from "services/placeNotes.services";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "store/auth/selectors";
import { useNavigate } from "react-router";

const RatingsPage = () => {
  const [bookingsToRate, setBookingsToRate] = useState([]);
  const { t } = useTranslation("global");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const accessToken = useSelector((state) => state.auth.token);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
      return;
    }

    const getBookings = async () => {
      try {
        const data = await getPlacenotes(accessToken);
        setBookingsToRate(data.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getBookings();
  }, [accessToken, isAuthenticated, navigate]);

  const handleRatingSubmitted = (submittedBookingId) => {
    setBookingsToRate(prevBookings =>
      prevBookings.filter(booking => booking.id !== submittedBookingId)
    );
  };

  if (error) {
    return <div className={styles.error}>{error}</div>;
  }

  return (
    <div className={`${styles.bookingsToRateListPage} ${loading ? styles.loading : ""}`}>
      <h1 className={styles.title}>{t("dashboard.ratings.title")}</h1>
      {bookingsToRate.length === 0 && !loading ? (
        <NoResultsSection
          title={t("dashboard.ratings.noResultTitle")}
          text={t("dashboard.ratings.noResultText")}
        />
      ) : (
        <ul className={styles.bookingsToRateList}>
          {bookingsToRate.map((booking) => (
            <SpaceToRateCard
              key={booking.id}
              booking={booking}
              onRatingSubmitted={() => handleRatingSubmitted(booking.id)}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

export default RatingsPage;